import { Markup, Problem } from '@yandex-int/k-common';
import { ProblemCoding, ProblemCodingMarkup } from '../../components/coding-problem/types';

const markupIsCodingMarkup = (markup: Markup | ProblemCodingMarkup): markup is ProblemCodingMarkup => {
    return Boolean((markup as ProblemCodingMarkup).languages);
};

export const checkProblemIsPythonCodingProblem = (problem: Problem | ProblemCoding) => {
    return (
        problem?.type === 'coding' &&
        markupIsCodingMarkup(problem?.markup) &&
        problem?.markup?.languages?.[0]?.language === 'python'
    );
};
